import React from 'react';
import {
  ArticleSearchResultType,
  BenefitArticleSearchResultType,
  CarSearchResultType,
  InternalSearchResultType,
  LocalArticleSearchResultType,
  LocalBenefitArticleSearchResultType,
  LocalDepartmentSearchResultType,
  SimpleSearchResultType,
} from '../../hooks/GlobalSearchTypes';
import { InternalSearchCardType } from '../layout/InternalSearchMetaData';
import { ArticleResultCard } from './Article';
import { BenefitResultCard } from './Benefit';
import { CarSearchResultCard } from './Car';
import { SimpleResultCard } from './Simple';
import { DefaultResultCard } from './Default';
import { LocalDepartmentResultCard } from './LocalDepartment';
import { LocalArticleResultCard } from './LocalArticle';
import { LocalBenefitResultCard } from './LocalBenefit';

interface Props {
  item: InternalSearchResultType;
}

export const SearchResultCard = ({ item }: Props) => {
  const type = item?.naf_page_type?.raw;
  if (type) {
    if (type === InternalSearchCardType.Article) {
      return <ArticleResultCard item={item as ArticleSearchResultType} />;
    }
    if (type === InternalSearchCardType.Car) {
      return <CarSearchResultCard item={item as CarSearchResultType} />;
    }
    if (type === InternalSearchCardType.Benefit) {
      return <BenefitResultCard item={item as BenefitArticleSearchResultType} />;
    }
    if (type === InternalSearchCardType.LocalDepartment) {
      return <LocalDepartmentResultCard item={item as LocalDepartmentSearchResultType} />;
    }
    if (type === InternalSearchCardType.LocalArticle) {
      return <LocalArticleResultCard item={item as LocalArticleSearchResultType} />;
    }
    if (type === InternalSearchCardType.LocalBenefit) {
      return <LocalBenefitResultCard item={item as LocalBenefitArticleSearchResultType} />;
    }
    if (type === InternalSearchCardType.Simple || type === InternalSearchCardType.NafCenterProduct) {
      return <SimpleResultCard item={item as SimpleSearchResultType} />;
    }
  }
  return <DefaultResultCard item={item as InternalSearchResultType} />;
};
